<template>
  <div class="form-area">
    <a href="#" class="logo"><img src="/images/logo.png" class="img-fluid"></a>

    <h1>Log In</h1>

    <div class="alert alert-danger" v-if="errorMsg != ''">
      {{ errorMsg }}
    </div>

    <div v-if="step == 1">
      <p>Please enter your email address</p>

      <form method="POST" @submit.prevent="verifyEmail">
        <div class="form-group">
          <input type="email" tabindex="1" name="email" id="loginEmail" ref="inputEmail" autofocus="on"
            :class="{'form-control form-control-lg': true, 'is-invalid': errors.has('email')}"
            v-validate.disable="{ required: true, email: true }"
            v-model="email" placeholder="Enter your email address">
          <div class="invalid-feedback">{{ errors.first('email') }}</div>
        </div>
        <button tabindex="2" class="btn btn-lg btn-block btn-primary"
          :disabled="state == 'verifying'">Continue <i class="fa fa-fw fa-angle-right"></i></button>
      </form>
    </div><!-- step 1 -->

    <div v-if="step == 2">
      <p>We've found <strong>{{ totalCompanies }} companies</strong> associated with your email, please select one you would like to work on</p>

      <div class="list-group mb-3">
        <template v-if="company">
          <a href="javascript:;" class="list-group-item text-decoration-none" @click="selectCompany">
            <h5 class="mb-0"><strong>{{ company.name }}</strong></h5>
          </a>
        </template>
        <a href="javascript:;" class="list-group-item text-decoration-none"
          v-for="(client, index) in clients" :key="client.id"
          @click="selectClient( index )">
          <h5 class="mb-1"><strong>{{ client.name }}</strong></h5>
          <small class="text-muted">As client of <strong>{{ client.company.name }}</strong></small>
        </a>
      </div>
      <div class="text-center">
        <button type="button" class="btn btn-link" @click="step = 1"><i class="fa fa-angle-left"></i> back</button>
      </div>
    </div><!-- step 2 -->

    <div v-if="step == 3">
      <p class="card-text">Please enter password for your account at <strong>{{ loginCompanyName }}</strong></p>

      <form method="POST" @submit.prevent="doLogin">
        <div class="form-group">
          <input type="password" name="password" placeholder="Enter password" ref="inputPassword"
            :class="{'form-control form-control-lg': true, 'is-invalid': errors.has('password')}"
            v-validate.disable="{ required: true }"
            v-model="password">
          <div class="invalid-feedback">{{ errors.first('password') }}</div>
        </div>
        <button class="btn btn-lg btn-block btn-primary"
          :disabled="state == 'logging'">Login</button>
        <div class="text-center mt-3">
          <button type="button" class="btn btn-link" @click="goBack"
            :disabled="state == 'logging'"><i class="fa fa-angle-left"></i> back</button>
        </div>
      </form>
    </div><!-- step 3 -->
  </div>
</template>

<script>
import auth from '@/services/auth'

export default {
  components: {
  },
  data () {
    return {
      env: process.env,
      state: '',
      step: 1,
      email: '',
      password: '',
      company: null,
      clients: [],
      loginAs: '',
      loginCompanyId: '',
      loginCompanyName: '',
      errorMsg: ''
    };
  },
  computed: {
    totalCompanies () {
      return this.clients.length + (this.company ? 1 : 0);
    },
  },
  watch: {
    step ( newVal ) {
      let self = this;
      if ( newVal == 3 ) {
        self.$nextTick(() => {
          self.$refs.inputPassword.focus();
        });
      }
    }
  },
  mounted () {
    this.$refs.inputEmail.focus();
  },
  methods: {
    verifyEmail () {
      let self = this;

      if (self.state != '') {
        return;
      }

      self.$validator.validateAll()
        .then(ok => {
          if ( ok ) {
            self.state = 'verifying';
            self.errorMsg = '';

            auth.verifyEmail(self.email, resp => {
              self.state = '';
              self.company = resp.company;
              self.clients = resp.clients;
              if ( self.totalCompanies == 0 ) {
                self.errorMsg = "Sorry, we couldn't find any account associated with your email address.";
              }
              else if ( self.totalCompanies == 1 ) {
                if ( self.company ) {
                  self.selectCompany();
                }
                else {
                  if (self.clients.length == 1 && !self.clients[0].member_enabled) {
                    self.errorMsg = "Sorry, your account is not active.";
                    return;
                  }
                  self.selectClient( 0 );
                }
              }
              else if ( self.totalCompanies > 1 ) {
                self.step = 2;
              }
            })
          }
        });
    },
    selectCompany () {
      let self = this;
      self.step = 3;
      self.loginAs = 'company';
      self.loginCompanyId = self.company.id;
      self.loginCompanyName = self.company.name;
    },
    selectClient ( index ) {
      let self = this;
      self.step = 3;
      self.loginAs = 'client';
      self.loginCompanyId = self.clients[index].id;
      self.loginCompanyName = self.clients[index].name;
    },
    goBack () {
      let self = this;
      if ( self.totalCompanies > 1 ) {
        self.step = 2;
      }
      else {
        self.step = 1;
      }
    },
    doLogin () {
      let self = this;

      if ( self.state != '' ) {
        return;
      }

      self.$validator.validateAll()
        .then(ok => {
          if ( ok ) {
            self.state = 'logging';
            self.errorMsg = '';

            auth.login(self.loginAs, self.loginCompanyId, self.email, self.password, resp => {
              if ( resp.status == 'SUCCESS' ) {
                self.$localStorage.set('access_token', resp.access_token);
                self.$localStorage.set('user_type_id', resp.user_type_id);
                self.$store.dispatch('INIT_APP')
                  .then(() => {
                    self.$router.push({ name: 'dashboard' });
                  });
              }
              else {
                self.state = '';
                self.errorMsg = resp.error;
              }
            }, error => {
              self.state = '';
              self.errorMsg = error.response.statusText;
            });
          }
        });
    }
  }
}
</script>
